import React from 'react';
import ReactDOM from 'react-dom';
import swal2 from "sweetalert2";
import 'sweetalert2/src/sweetalert2.scss';
import MaskedInput from 'react-text-mask';
import DatePicker from 'react-datepicker';

class CustomersCheckout extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.sendRequest = this.sendRequest.bind(this);
        //this.validateEmail = this.validateEmail.bind(this);
        this.acceptTerms = this.acceptTerms.bind(this);
        this.validateDate = this.validateDate.bind(this);

        this.state = {
            user: {},
            token: {},
            promo: {},
            tdc: "",
            internalIP: "",
            coupons: [],
            loading: false,
            equalMail: null,
            terms: false,
            pdfUrl: "",
            months: [],
            days: [],
            years: [],
            text_terms: "Da clic para aceptar"
        };
    }

    componentWillMount() {
        let self = this;

        /*
        let months = [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ];
        */

        let months = [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12"
        ];


        let days = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
        let years = [];

        for (let i = 1920; i < 1995; i++) {
            years.push(i);
        }

        self.setState({
            months: months,
            days: days,
            years: years
        });
    }

    componentDidMount() {
        let self = this;
        let id_token = self.props.id_token;
        let id_promo = self.props.id_promo;

        axios.get(location.origin + '/api/customers/checkout/' + id_token + '/' + id_promo)
            .then(response => {
                self.setState({
                    token: response.data.token,
                    promo: response.data.promo
                });
            })
            .catch(error => {

                let error_rs = error.response.data;

                switch (error_rs) {
                    case 'already_registered':
                        $('#checkout_main_div').remove();

                        swal2({
                            imageUrl: '/img/headerAlert.png',
                            imageClass: 'img-responsive',
                            html:
                                '<h4 class="sivale-swal2-title">¡Ya solicitaste tu promoción!</h4>'+
                                '<p class="sivale-swal2-content">' +
                                'Recuerda que solo puedes pedir una promoción mensual. No olvides solicitar tu cupón Devlyn con ' +
                                'valor de $500 M.N. llamando al 01 (800) 704 6427' +
                                '</p>'+
                                '<img src="/img/devlinAlert.png" class="center-block sivale-swal2-img" alt=""><br/><br/> ¡Te esperamos el próximo mes!',
                            showCancelButton: false,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });

                        break;

                    default:
                        swal2({
                            imageUrl: 'img/modalError.png',
                            imageClass: 'img-responsive',
                            html:
                                '<h4 class="sivale-swal2-title">¡Ha ocurrido un error!</h4>',
                            showCancelButton: false,
                            showConfirmButton: false,
                            closeOnClickOutside: false,
                        });
                        break;
                }

            });

        /*
        let ua = window.navigator.userAgent;
        let msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            console.log("IE");
        } else {
        */
            window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;//compatibility for Firefox and chrome
            let pc = new RTCPeerConnection({iceServers: []}), noop = function () {
            };
            pc.createDataChannel('');
            pc.createOffer(pc.setLocalDescription.bind(pc), noop);
            pc.onicecandidate = function (ice) {
                if (ice && ice.candidate && ice.candidate.candidate) {
                    let myIP = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
                    self.setState({
                        internalIP: myIP
                    });
                    pc.onicecandidate = noop;
                }
            };
        //}
    }

    handleChange({target}) {
        let self = this;

        let user = self.state.user;
        user[target.id] = target.value;

        if (target.id === 'email2') {
            let email2 = $('#email2').val();

            if (self.state.user.email === email2)
                self.setState({
                    equalMail: true
                });
            else
                self.setState({
                    equalMail: false
                });
        }

        self.setState({
            user: user
        });

    }

    validateDate()
    {
        let self = this;
        let user_date = self.state.user.birthday;

        if (user_date.length === 10) {
            let parts = user_date.split('/');
            let mydate = new Date(parts[2], parts[1] - 1, parts[0]);
            if (mydate.getMonth()+1 === parseInt(parts[1])) {
                return true;
            } else {
                swal2({
                    imageUrl: '/img/modalError.png',
                    imageClass: 'img-responsive img-error',
                    titleText: "Datos incompletos",
                    text: "La fecha ingresada no es correcta.",
                });
                return false;
            }
        }

        return false;
    }

    save()
    {
        let self = this;
        let user = self.state.user;

        if (!user['name'] || user['name'].length < 10) {
            swal2({
                imageUrl: '/img/modalError.png',
                imageClass: 'img-responsive img-error',
                titleText: "Datos incompletos",
                text: "El nombre ingresado no cumple con la longitud mínima.",
            });

            return null;
        }

        if (!this.validateDate()) {
            return null;
        }

        user['phone'] = user['phone'].replace(/ /g, '');

        if (!user['phone'] || user['phone'].length !== 10) {
            swal2({
                imageUrl: '/img/modalError.png',
                imageClass: 'img-responsive img-error',
                titleText: "Datos incompletos",
                text: "El número celular debe contener 10 dígitos.",
            });

            return null;
        }

        if (!user['name'] || !user['email'] || !user['birthday'] || !user['phone']) {
            swal2({
                imageUrl: '/img/modalError.png',
                imageClass: 'img-responsive img-error',
                titleText: "Oh no",
                text: "Para poder continuar, debes completar todos los campos.",
            });
            return null;
        } else {
            if (user['email'] === user['email2']) {
                if (self.state.terms === true) {

                    user['tdc'] = self.state.token.tdc;
                    user['id_promo'] = self.state.promo.id;
                    //user['internalIP'] = self.state.internalIP;
                    user['id_token'] = self.state.token.id;

                    swal2({
                        imageUrl: '/img/un_momento.png',
                        imageClass: 'img-responsive',
                        text: 'Estamos procesando tu solicitud',
                        showCancelButton: false,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    self.setState({
                        user: user
                    });

                    self.sendRequest();

                } else {
                    swal2({
                        imageUrl: '/img/modalError.png',
                        imageClass: 'img-responsive img-error',
                        titleText: "Oh no",
                        text: "Para poder continuar, debes aceptar los términos y condiciones.",
                    });
                }
            } else {
                swal2({
                    imageUrl: '/img/modalError.png',
                    imageClass: 'img-responsive img-error',
                    titleText: "Oh no",
                    text: "El correo electrónico no coincide.",
                });
            }
        }

    }

    sendRequest() {
        let self = this;

        axios.post(location.origin + '/api/customers/save/' + project, self.state.user)
            .then(response => {
                swal2({
                    imageUrl: '/img/headerAlert.png',
                    imageClass: 'img-responsive',
                    html:
                        '<h4 class="sivale-swal2-title">¡Felicidades!</h4>'+
                        '<p class="sivale-swal2-content">' +
                        'Hemos enviado tu cupón al número telefónico que nos has proporcionado' +
                        '</p>'+
                        '<br/> ¡Te esperamos el próximo mes!',
                    showCancelButton: false,
                    showConfirmButton: false,
                    allowEnterKey: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    timer: 4000,
                }).then(() => window.location.replace('/welcome'));
            })
            .catch(error => {
                let err = error.response.data;
                let title = "";
                let message = "";

                $("#customerForm :input").attr("disabled", true);

                switch (err) {
                    case 'already_registered':
                        swal2({
                            imageUrl: '/img/headerAlert.png',
                            imageClass: 'img-responsive',
                            html:
                                '<h4 class="sivale-swal2-title">¡Promoción del mes reclamada!</h4>'+
                                '<p class="sivale-swal2-content">' +
                                'Recuerda que solo puedes pedir una promoción mensual. No olvides solicitar tu cupón Devlyn con ' +
                                'valor de $500 M.N. llamando al 01 (800) 704 6427' +
                                '</p>'+
                                '<img src="/img/devlinAlert.png" class="center-block sivale-swal2-img" alt="">',
                            showCancelButton: false,
                            showConfirmButton: false,
                            closeOnClickOutside: false,
                        });

                        break;
                    case 'no_more_coupons':
                        swal2({
                            imageUrl: '/img/headerAlert.png',
                            imageClass: 'img-responsive',
                            html:
                                '<h4 class="sivale-swal2-title">¡Promoción agotada!</h1>'+
                                '<p class="sivale-swal2-content">' +
                                'Recuerda que solo puedes pedir una promoción mensual. No olvides solicitar tu cupón Devlyn con ' +
                                'valor de $500 M.N. llamando al 01 (800) 704 6427' +
                                '</p>'+
                                '<img src="/img/devlinAlert.png" class="center-block sivale-swal2-img" alt="">',
                            showCancelButton: false,
                            showConfirmButton: false,
                            closeOnClickOutside: false,
                        });

                        break;
                    case "NO_TIENE":
                        title = "¡Producto no activo!";
                        message = "El número de Tarjeta ingresado no tiene activado el producto DESCLUB UP BENEFICIOS BIENESTAR, llama al 01 (55) 5328 1087 y goza de este y más beneficios.";

                        swal2({
                            imageUrl: '/img/modalError.png',
                            imageClass: 'img-responsive img-error',
                            titleText: title,
                            text: message,
                        });
                        break;
                    case "error_ws":
                        title = "¡Se ha producido un error!";
                        message = "Se ha producido un error al redimir esta promoción, inténtalo de nuevo más tarde.";

                        swal2({
                            imageUrl: '/img/modalError.png',
                            imageClass: 'img-responsive img-error',
                            titleText: title,
                            text: message,
                        });
                        break;
                    case "fraud":
                        title = "¡Se ha producido un error!";
                        message = "Se ha producido un error al redimir esta promociones, inténtalo de nuevo más tarde.";

                        swal2({
                            imageUrl: '/img/modalError.png',
                            imageClass: 'img-responsive img-error',
                            titleText: title,
                            text: message,
                        });
                        break;
                    default:
                        swal2({
                            imageUrl: 'img/modalError.png',
                            imageClass: 'img-responsive',
                            html:
                                '<h4 class="sivale-swal2-title">¡Ha ocurrido un error!</h4>',
                            showCancelButton: false,
                            showConfirmButton: false,
                            closeOnClickOutside: false,
                        });
                        break;
                }
            });
    }

    acceptTerms() {
        let self = this;

        if (self.state.terms === false) {
            self.setState({
                terms: true,
                text_terms: "He leído y acepto "
            });
            $('#termsButton').addClass('button-primary').removeClass('button-primary-outline');
        } else {
            self.setState({
                terms: false,
                text_terms: "Da clic para aceptar "
            });
            $('#termsButton').addClass('button-primary-outline').removeClass('button-primary');
        }
    }

    renderCoupons(item) {
        let self = this;

        let imgStyle = {
            width: "200px",
            maxHeight: "300px",
            maxWidth: "300px",
            margin: "15px 15px 15px 15px"
        };

        let pin = item.pin.length === 0 ? "Sin pin asignado" : "Pin: " + item.pin;

        return (
            <div className="col-md-12" key={item.id}>
                <div className="card">
                    <div className="row">
                        <div className="col-md-6">
                            <img src={item.qr_url} className="img-responsive text-center" style={imgStyle}/>
                        </div>
                        <div className="col-md-6">
                            <br className="visible-lg"/>
                            <h5>Cupón</h5>
                            <h3>{item.number}</h3>
                            <h6 style={{fontWeight: "normal"}}>{pin}</h6>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderAges(item) {
        return (
            <option value={item}>{item}</option>
        );
    }

    showModalTermsTA() {
        swal2({
            imageUrl: '/img/headerAlert.png',
            imageClass: 'img-responsive',
            html:
                '<h4 class="sivale-swal2-title">Términos y condiciones Tiempo Aire</h4>'+
                '<p>' +
                '1. Si el cliente elige esta opción de canje tendrá que proporcionar al sistema vía web su compañía telefónica celular y los 10 dígitos de su número celular.\n' +
                '<br/>2. Al enviar esta información recibirá la confirmación de bonificación por mail en un plazo máximo de 10 minutos.\n' +
                '<br/>3. Algunas compañías como Telcel notifican vía sms la bonificación de Saldo.\n' +
                '<br/>4. En el caso de que la compañía no notifique al cliente la bonificación de el saldo el podrá corroborar la bonificación marcando al número especial de su compañía asignado para este propósito.\n' +
                '<br/>5. No aplica para números telefónicos que tengan asignado algún plan de prepago.' +
                '</p>',
            showCancelButton: false,
            showConfirmButton: false,
            closeOnClickOutside: false,
        });
    }

    renderBirthday(item)
    {
        return(
            <option key={item} value={item}>{item}</option>
        );
    }

    render() {
        /*
        * <div className="col-md-12">
        *     <div className="form-wrap">
        *         <h6>Edad</h6>
        *         <select onChange={this.handleChange} className="form-input form-control-has-validation"
        *         id="range_age" name="range_age">
        *         <option value={null}>Selecciona un rango de edad</option>
        *         {this.state.age_ranges.map(this.renderAges.bind(this))}
        *         </select>
        *         </div>
        *         </div>*/

        let icon = "fa fa-save";
        let text = "Enviar";

        if (this.state.loading === true) {
            icon = "fa fa-spinner fa-spin";
            text = "Enviando";
            $('#sivaleSaveButton').prop('disabled', true);
        } else {
            icon = "fa fa-save";
            text = "Guardar";
            $('#sivaleSaveButton').prop('disabled', false);
        }

        return (
            <div id="checkout_main_div">
                <section className="section-35 bg-whisper section-sivale" >
                    <div className="container bg-whisper" >
                        <div className="container-sivale" style={{ borderRadius: "30px" }}>
                            <div className="col-md-12">
                                <div className="col-md-6 col-xs-12 text-center"
                                     style={{ marginTop: "40px", marginLeft: "20px" }}>
                                    <h2 style={{ color: "#FFFFFF" }}>
                                        {this.state.promo.description}
                                    </h2>
                                </div>
                                <div className="col-md-5 text-center" style={{ marginTop: "30px" }}>
                                    <br className="visible-xs"/>
                                    <br className="visible-xs"/>
                                    <img src={this.state.promo.url_image} alt={""} width={"220px"} height={"auto"}
                                         className="img-responsive center-block" />
                                </div>
                            </div>

                            <div className="col-md-12" style={{ marginTop: "30px" }}>
                                <div className="col-md-6 col-xs-11 sivale-form-checkout center-block" style={{ marginLeft: "20px" }}>
                                    <form id="customerForm" className="sivale-form" style={{ marginLeft: "20px", marginRight: "20px" }}>
                                        <br/>
                                        <h5 className="label-sivale text-center">Para continuar, por favor completa el siguiente formulario.</h5>
                                        <div className="row row-30">

                                            <div className="col-md-12">
                                                <div className="form-wrap">
                                                    <h5 className="label-sivale">Nombre completo</h5>
                                                    <input className="form-input input-md-sivale"
                                                           type="text" id="name" name="name"
                                                           onChange={this.handleChange} autoFocus={true}/>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-wrap">
                                                    <h5 className="label-sivale">Email</h5>
                                                    <input className="form-input input-md-sivale"
                                                           id="email" type="text" name="email"
                                                           onChange={this.handleChange}/>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-wrap">
                                                    <h5 className="label-sivale">Confirma tu email</h5>
                                                    <input className="form-input input-md-sivale"
                                                           id="email2" type="text" name="email2"
                                                           onChange={this.handleChange}/>
                                                </div>
                                                {
                                                    this.state.equalMail === false &&
                                                    <span className="text-danger">Correo electrónico no coincide.</span>
                                                }
                                            </div>

                                            <div className="col-md-12" style={{ marginBottom: '15px !important' }}>
                                                <div className="form-wrap">
                                                    <h5 className="label-sivale">Fecha de nacimiento</h5>
                                                    <MaskedInput mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                                                                 id="birthday" name="birthday" onChange={this.handleChange} onBlur={this.validateDate} type="text" inputMode="numeric"
                                                                 className="form-input input-md-sivale"/>
                                                </div>
                                                <div className="text-center">
                                                    <small>(DD/MM/AAAA)</small>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-wrap">
                                                    <h5 className="label-sivale">
                                                        Número celular
                                                        <small
                                                            className="d-block"
                                                            style={{ marginBottom: '8px' }}
                                                        >
                                                            (Lo usaremos para contactarte y poder entregarte tu cupón)
                                                        </small>
                                                    </h5>
                                                    <MaskedInput
                                                        mask={[/\d/, /\d/,' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]}
                                                        id="phone"
                                                        name="phone"
                                                        onChange={this.handleChange}
                                                        type="text"
                                                        inputMode="numeric"
                                                        guide={false}
                                                        className="form-input input-md-sivale"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-12 text-center">
                                                <button type="button"
                                                        className="button button-sm button-primary-outline button-block btn-checkout"
                                                        onClick={this.acceptTerms} id="termsButton">
                                                    {this.state.text_terms} los términos y
                                                    condiciones de esta promoción.
                                                </button>
                                                <strong>
                                                    {
                                                        (this.state.promo.terms === null && this.state.promo.name === "Tiempo Aire") &&
                                                        <a href={"javascript:void(0)"} onClick={this.showModalTermsTA.bind(this)}>
                                                            Consultar términos y condiciones
                                                        </a>
                                                    }
                                                    {
                                                        (this.state.promo.terms !== null) &&
                                                        <a href={this.state.promo.terms} target="_blank">
                                                            Consultar términos y condiciones
                                                        </a>
                                                    }

                                                </strong>
                                            </div>

                                            <div className="col-md-12">
                                                <button className="button button-primary-outline button-block btn-checkout"
                                                        type="button" id="sivaleSaveButton"
                                                        onClick={this.save}>
                                                    SIGUIENTE
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-md-5 text-center hidden-xs hidden-sm" style={{ marginTop: "30px" }}>
                                    <img src={this.state.promo.checkout_image_url} alt={""} height={"80%"}
                                         className="img-responsive center-block visible-lg visible-md" />
                                </div>
                            </div>

                            <div className={"clearfix"}></div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default CustomersCheckout;

if (document.getElementById('customers_checkout-component')) {
    ReactDOM.render(<CustomersCheckout id_token={id_token} id_promo={id_promo}/>,
        document.getElementById('customers_checkout-component'));
}


// WEBPACK FOOTER //
// ./resources/assets/react/CustomersCheckout.jsx